import { forwardRef } from 'react';
import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

type Accent = 'default' | 'violet' | 'cyan' | 'emerald';

interface TileProps extends HTMLAttributes<HTMLDivElement> {
  accent?: Accent;
  interactive?: boolean;
  padded?: boolean;
  children: ReactNode;
}

const ACCENT_RING: Record<Accent, string> = {
  default: '',
  violet: 'ring-1 ring-violet/15',
  cyan: 'ring-1 ring-cyan/15',
  emerald: 'ring-1 ring-emerald/20',
};

export const Tile = forwardRef<HTMLDivElement, TileProps>(function Tile(
  { accent = 'default', interactive = false, padded = false, className, children, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'relative min-w-0 rounded-[14px] border border-line-1 bg-bg-1 shadow-card transition-[border-color,box-shadow,background-color] duration-200',
        ACCENT_RING[accent],
        interactive && 'surface-card-hover cursor-pointer',
        padded && 'p-4 sm:p-5',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
});
